enum ReferencingType {
  ALARECEPTION,
  ALARTICLE,
}
export default ReferencingType;
